module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-battles-bg.46fce3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-battles-bg.jpg
// module id = 3160
// module chunks = 11